var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech-list"},_vm._l((_vm.techList),function(item,index){return _c('div',{key:item.title,class:[
      'list-item',
      index == _vm.current
        ? 'back animate__animated animate__fadeIn animate__duration-0.5s'
        : ''
    ],on:{"mouseenter":function($event){return _vm.handleMouse(index)},"mouseleave":function($event){return _vm.handleMouse(index)}}},[_c('img',{attrs:{"src":index == _vm.current ? item.hoverImg : item.defaultImg}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(item.desc))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }